var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Checkbox, Radio } from '@mui/material';
import clsx from 'clsx';
import { memo, useCallback } from 'react';
import useStyles from './styles';
function CheckboxFilter(_a) {
    var val = _a.val, isSelected = _a.isSelected, selectProp = _a.select, className = _a.className, disabled = _a.disabled, onlyOneSelect = _a.onlyOneSelect;
    var styles = useStyles({});
    var select = useCallback(function () {
        selectProp(val.key);
    }, [val.key, selectProp]);
    return (_jsxs("div", __assign({ className: clsx(styles.checkboxWrapper, className) }, { children: [onlyOneSelect ? (_jsx(Radio, { checked: isSelected, onChange: select, color: "primary", disabled: disabled, className: styles.checkbox })) : (_jsx(Checkbox, { checked: isSelected, onClick: select, className: styles.checkbox, disabled: disabled, color: "primary" })), _jsx("span", __assign({ className: styles.checkboxWrapperLabels }, { children: val.label }))] })));
}
export default memo(CheckboxFilter);
//# sourceMappingURL=FilterCheckbox.js.map